import { Component, Input, ChangeDetectorRef, AfterViewInit, OnInit } from '@angular/core';

/**
 * Video content component (title + player). Does not render a modal.
 * Consumers should either wrap in bw-modal-legacy or open via global modal service with this as template content.
 */
@Component({
    selector: 'bw-video-legacy',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    standalone: false
})
export class VideoComponentLegacy implements OnInit, AfterViewInit {
  @Input() title = '';
  /** When false, title is not rendered (e.g. when modal already shows the title). */
  @Input() showTitle = true;
  @Input() cdnBase = '';
  @Input() path = '';
  @Input() isMp4 = false;
  
  fullVideoPath = '';
  

  constructor(private cdRef: ChangeDetectorRef) {
    /* ToDo: need tracking on video playback */
  }

  ngOnInit() {
    if (this.path.includes('mp4')) this.isMp4 = true;
    this.fullVideoPath = `${this.cdnBase}${this.path.replace('video:', '')}`;
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }
}
